import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  margin: 0;
  box-shadow: inset 1px 1px 5px rgba(0, 0, 0, 0.05);
  background: rgba(0, 0, 0, 0.01);

  @media (max-width: 1024px) {
    margin: 0;
    width: 100%;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 50%;
  background: ${({ theme }) =>
    `linear-gradient(to right,rgba(0,0,0,0.05), rgba(0,0,0,0))`};

  padding: 2rem 0rem 4rem 2rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    padding: 1.5rem;
    padding-bottom: 4rem;
    max-width: 100%;
  }
`;

export const Title = styled.div`
  width: 100%;
  box-shadow: inset 1px 1px 5px rgba(0, 0, 0, 0.05);
  padding: 2rem 0 2rem 2rem;
  background: ${({ theme }) =>
    `linear-gradient(to right,rgba(0,0,0,0.05), rgba(0,0,0,0))`};

  display: flex;
  flex-direction: row;
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.1);

  div {
    display: flex;
    width: 50%;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  h1 {
    align-items: center;
    display: flex;
    font-size: 2rem;
    font-weight: 500;
    color: #333;
    
    span {
      margin-left: 1rem;
    }
  }

  button {
    height: 56px;
    width: 56px;
    position: relative;
    background: #333;
    border-radius: 100%;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;
    display: flex;
    float: right;
    align-items: center;

    &:hover {
      background: #000;
      text-decoration: underline;
    }
  }

  @media (max-width: 1024px) {
    align-items: flex-start;

    padding: 1.5rem;

    h1 {
       font-size: 1rem;
    }
    div {
      width: 100%;
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2px;
  background: #ccc;
  
  @media (max-width: 1024px) {
    
  }
`;

export const Control = styled.div`
  height: 50px;
  position: relative;
  background: #333;
  border-radius: 8px;
  padding: 0 2rem;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease;
  margin-top: -1rem;

  &:hover {
    background: #000;
    text-decoration: underline;
  }


  span {
    color: #fff;
  }

  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 1024px) {
    height: 40px;
    font-size: 0.8rem;
  }

`;
